import TicketService from '@/services/tickets';

class Bet {
  /**
  * @constructor Bet
  * @param {Object} match
  * @param {Object} bet
  * @param {Object} outcome
  */
  constructor(match, bet, outcome) {
    this.idMatch = match.idMatch;
    this.matchName = match.matchName;
    this.team1Name = match.homeTeam.name;
    this.team2Name = match.awayTeam.name;
    this.matchDateTimeUTC = match.matchDateTimeUTC;
    this.matchDateTime = match.matchDateTime;
    this.matchDisplayId = match.matchDisplayId;
    this.bettingStatus = match.bettingStatus;
    this.idMb = bet.idBet;
    this.idBet = bet.idBet;
    this.mbSpecialValue = bet.betSpecialValue || '';
    this.betDisplayId = bet.betDisplayId;
    this.betName = bet.betDisplayName || bet.betName;
    this.mboOddValue = outcome.outcomeOdd;
    this.betOutcomeName = outcome.outcomeDisplayName;
    this.betOutcomeShortcut = outcome.outcomeShortcut;
    this.mboType = outcome.outcomeType;
    this.mboActive = outcome.outcomeActive;
    this.betUuid = TicketService.makeRequestUuid(2);
  }
}
class ReBet {
  /**
   * @constructor ReBet
   * @param {Object} data
   * @param {String} betStatus
   */
  constructor(data, betStatus) {
    this.idMatch = data.matchId;
    this.matchName = data.matchDisplayName;
    this.team1Name = data.teams[0].teamDisplayName;
    this.team2Name = data.teams[1].teamDisplayName;
    this.matchDateTimeUTC = data.matchDateTimeUTC;
    this.matchDateTime = data.matchDateTime;
    this.matchDisplayId = data.matchDisplayId;
    this.bettingStatus = betStatus;
    this.idMb = data.idBet;
    this.idBet = data.bet.idBet;
    this.mbSpecialValue = data.betSpecialValue;
    this.betDisplayId = data.bet.betDisplayId;
    this.betName = data.bet.betDisplayName;
    this.mboOddValue = data.oddValue;
    this.betOutcomeName = data.betOutcome.betOutcomeDisplayName;
    this.betOutcomeShortcut = data.betOutcome.outcomeShortcut;
    this.mboType = data.outcomeType;
    this.betUuid = TicketService.makeRequestUuid(2);
  }
}
export {
  Bet,
  ReBet,
};
